import React from 'react';

export default function SingleStoreyA(props) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" data-testid="single-storey-a" {...props}>
    <circle cx="46" cy="54" r="28" stroke="currentColor" strokeWidth="10" />
    <path d="M74 26V82" stroke="currentColor" strokeWidth="10" strokeLinecap="round" />
  </svg>;
}
